import { Language } from '../../../enums/const-enums';

export interface RassAccountNrTranslations {
  account_number: {
    label: string;
    hint: string;
    format_error: string;
    placeholder_prefix: string;
  };
}

const nlTranslations: RassAccountNrTranslations = {
  account_number: {
    label: 'Rekeningnummer',
    hint: 'Laatste 9 cijfers van het rekeningnummer',
    format_error: 'Rekeningnummer is onjuist',
    placeholder_prefix:
      'Je bent in het rekeningnummer tekstveld. De samenvatting van de opdracht wordt nu opgelezen.',
  },
};

const enTranslations: RassAccountNrTranslations = {
  account_number: {
    label: 'Account number',
    hint: 'Last 9 digits of your account number',
    format_error: 'Account number invalid',
    placeholder_prefix:
      'You are in the account number text field. The summary of the task will now be read.',
  },
};

export const rassAccountNrTranslations = {
  [Language.NL]: nlTranslations,
  [Language.EN]: enTranslations,
  [Language.ES]: enTranslations,
  [Language.PT]: enTranslations,
};
